// home-editor-06 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Título da linha (opcional)": "Título de la fila (opcional)",
};

export default catalogo;
